// extracted by mini-css-extract-plugin
module.exports = {"footerItems":"footer_footerItems__whKPO","returnTopButton":"footer_returnTopButton__bvREu","watermark":"footer_watermark__1AhIx"};